class Schedule {
  constructor(
    day,
    start,
    end
  )
  {
    if (!(Days.includes(day))) {
      throw new Error(`'day' must be one of ["月", "火", "水", "木", "金", "土", "日"]. But ${day} is not.`)
    }
    if (!(typeof start === 'string')) {
      throw new TypeError(`The type of 'start' must be String. Actual: ${typeof start}`)
    }
    if (!(typeof end === 'string')) {
      throw new TypeError(`The type of 'end' must be String. Actual: ${typeof end}`)
    }
    this.day = day
    this.start = start
    this.end = end
  }

  static createFromObject(object) {
    if (!(object instanceof Object)) {
      throw new TypeError(`The type of object must be [object Object]. Actual: ${typeof object}`)
    }
    return new Schedule(
      object.day,
      object.start,
      object.end
    )
  }

  static createFromDate(date, start, end) {
    if (!(date instanceof Date)) {
      throw new TypeError(`The type of 'date' must be [object Date]. Actual: ${typeof date}`)
    }
    if (!(typeof start === "string")) {
      throw new TypeError(`The type of 'start' must be String. Actual: ${typeof start}`)
    }
    if (!(typeof end === "string")) {
      throw new TypeError(`The type of 'end' must be String. Actual: ${typeof end}`)
    }
    const day = numToDay[date.getDay()]
    return new Schedule(
      day,
      start,
      end
    )
  }

  toObject() {
    return {
      day: this.day,
      start: this.start,
      end: this.end
    }
  }

  update(scheduleObject) {
    if (!(scheduleObject instanceof Object)) {
      throw new TypeError(`The type of 'scheduleObject' [object Object]. Actual: ${typeof scheduleObject}`)
    }
    if (!(scheduleObject.day)){
      throw new Error(`'scheduleObject' must have an property: 'day' of String.`)
    }
    if (!(scheduleObject.start)){
      throw new Error(`'scheduleObject' must have an property: 'start' of String.`)
    }
    if (!(scheduleObject.end)){
      throw new Error(`'scheduleObject' must have an property: 'end' of String.`)
    }
    this.day = scheduleObject.day
    this.start = scheduleObject.start
    this.end = scheduleObject.end
    return this
  }

  toString() {
    if (this.day !== "" & this.start !== "" & this.end !== "") {
      return this.day + ' ' + this.start + '-' + this.end
    }
  }

  is(other) {
    if (!(other instanceof Schedule)) {
      throw new TypeError(`'other' must be an instance of [object Schedule]. Actual: ${typeof other}`)
    }
    return (this.day === other.day & this.start === other.start & this.end === other.end)
  }

  hasDay(day) {
    if (!(typeof day === "string")) {
      throw new TypeError(`The type of 'day' must be String. Actual: ${typeof day}`)
    }
    return (this.day === day)
  }

  updateDay(day){
    if (!(typeof day === "string")) {
      throw new TypeError(`The type of 'day' must be String. Actual: ${typeof day}`)
    }
    this.day = day
    return this
  }

  updateStart(start) {
    if (!(typeof start === "string")) {
      throw new TypeError(`The type of 'start' must be String. Actual: ${typeof start}`)
    }
    this.start = start
    return this
  }

  updateEnd(end) {
    if (!(typeof end === "string")) {
      throw new TypeError(`The type of 'end' must be String. Actual: ${typeof end}`)
    }
    this.end = end
    return this
  }

  countDatesFrom(now) {
    if (!(now instanceof Date)) {
      throw new TypeError(`'now' must be an instance of [object Date]. Actual: ${typeof now}`)
    }
    const d = now.getDay()
    return dayToNum[this.day] - d
  }

  countHoursFrom(now) {
    if (!(now instanceof Date)) {
      throw new TypeError(`'now' must be an instance of [object Date]. Actual: ${typeof now}`)
    }
    const h = now.getHours()
    return this.start.split(":")[0] - h
  }
}

class Schedules {
  constructor(schedules){
    this.schedules = schedules
  }

  static createFromObjects(objects) {
    if (!(objects instanceof Array)) {
      throw new TypeError(`'objects' must be an instance of Array. Actual: ${typeof objects}`)
    }
    const arr = objects.map(obj => {
      return Schedule.createFromObject(obj)
    })
    return new Schedules(arr)
  }

  get() {
    return this.schedules
  }

  set(schedules) {
    if (!(schedules instanceof Array)) {
      throw new TypeError(`'schedules' must be an instance of [object Array]. Actual: ${schedules}`)
    }
    this.schedules = schedules
    return this
  }

  length() {
    return this.schedules.length
  }

  toObjects(){
    return this.schedules.map(schedule => {
      return schedule.toObject()
    })
  }

  toStrings() {
    return this.schedules.map(schedule => {
      return schedule.toString()
    }).filter(schedule => {
      return (typeof schedule === "string")
    })
  }

  register(schedule) {
    if (!(schedule instanceof Schedule)) {
      throw new TypeError(`'schedule' must be an instance of [object Schedule]. Actual: ${typeof schedule}`)
    }
    this.schedules.push(schedule)
    return this
  }

  add(others) {
    if (!(others instanceof Schedules)) {
      throw new TypeError(`'others' must be an instance of [object Schedules]. Actual: ${typeof others}`)
    }
    this.schedules = [...this.schedules, ...others.schedules]
    return this
  }

  remove(schedule) {
    if (!(schedule instanceof Schedule)) {
      throw new TypeError(`'schedule' must be an instance of [object Schedule]. Actual: ${typeof schedule}`)
    }
    this.schedules.splice(
      this.schedules.findIndex(s => {
        return s.is(schedule)
      }), 1)
    return this
  }

  has(schedule) {
    if (!(schedule instanceof Schedule)) {
      throw new TypeError(`'schedule' must be instance of [object Schedule]. Actual: ${typeof schedule}`)
    }
    return this.schedules.some(s => s.is(schedule))
  }

  hasDayInAny(day) {
    if (!(typeof day === "string")) {
      throw new TypeError(`The type of 'day' must be String. Actual: ${typeof day}`)
    }
    return this.schedules.some(s => s.hasDay(day))
  }

  addNew() {
    this.schedules.push(
      new Schedule("", "", "")
    )
  }

  diff(others) {

  }

  updateSchedule(index, schedule) {
    if (!(typeof index === "number")) {
      throw new TypeError(`The type of 'index' must be Number. Actual: ${typeof index}`)
    }
    if (!(schedule instanceof Schedule)) {
      throw new TypeError(`'Schedule' must be an instance of [object Schedule]. Actual: ${typeof schedule}`)
    }
    this.schedules[index] = schedule
    return this
  }

}

const Days = [
  "",
  "月",
  "火",
  "水",
  "木",
  "金",
  "土",
  "日"
]

const dayToNum = {
  "月": 1,
  "火": 2,
  "水": 3,
  "木": 4,
  "金": 5,
  "土": 6,
  "日": 0
}

const numToDay = {
  1: "月",
  2: "火",
  3: "水",
  4: "木",
  5: "金",
  6: "土",
  0: "日"
}

export { Schedule, Schedules}